import { inkBorderTokens } from '@ds/tokens'

const border = {
  defaultColor: inkBorderTokens.borderColorDefault,
  emphasisColor: inkBorderTokens.borderColorEmphasis,
  subtleColor: inkBorderTokens.borderColorSubtle,
} as const

export default border
